import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Box, Grid, Typography } from "@mui/material";
import { useAuth } from "../hooks/use-auth";
import CustomizedButton from "../components/Custom/CustomizedButton";
import GlobalService from "../services/Global";

const AdminMaintenance = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();

  if (user && user?.document_id !== "EP-0000000001") {
    navigate("/unauthorized");
  }

  const clearQueue = async () => {
    try {
      await GlobalService.clearQueue();
      enqueueSnackbar("ล้างคิวสำเร็จ", { variant: "success" });
    } catch (err) {
      enqueueSnackbar("ล้างคิวไม่สำเร็จ (server issue)", { variant: "error" });
    }
  };

  return (
    <>
      <Box>
        <Typography variant="h5">Admin Maintenance</Typography>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={1}>
          <CustomizedButton
            title={"Clear Queue"}
            variant="outlined"
            size="medium"
            onClick={clearQueue}
          />
        </Grid>
      </Box>
    </>
  );
};

export default AdminMaintenance;
